import * as React from 'react';
import { IconButton, TextField, TooltipDelay, TooltipHost } from '@fluentui/react';

let nextTooltipId = 0;

interface CopyableTextFieldState {
    valueCopied: boolean
}

interface CopyableTextFieldProps {
    fieldLabel: string,
    showLabel: boolean,
    copyableValue: string
}

export class CopyableTextField extends React.Component<CopyableTextFieldProps, CopyableTextFieldState> {
    private readonly tooltipId = `copy-tooltip-${nextTooltipId++}`;

    constructor(props: CopyableTextFieldProps) {
        super(props);

        this.state = {
            valueCopied: false
        }
    }

    renderCopyButton = (): JSX.Element => (
        <TooltipHost
            content={this.state.valueCopied ? 'Copied to clipboard!' : `Copy ${this.props.fieldLabel}`}
            id={this.tooltipId}
            delay={TooltipDelay.zero}
            onTooltipToggle={(isTooltipVisible: boolean) => !isTooltipVisible && this.setState({ valueCopied: false }) }
        >
            <IconButton
                iconProps={{ iconName: 'Copy', styles: { root: { color: '#000' } } }}
                ariaLabel={`Copy ${this.props.fieldLabel}`}
                onClick={() => {
                    navigator.clipboard.writeText(this.props.copyableValue);
                    this.setState({ valueCopied: true });
                }}
                styles={{ rootHovered: { backgroundColor: 'transparent' }, rootPressed: { backgroundColor: 'transparent' } }}
                aria-describedby={this.tooltipId}
            />   
        </TooltipHost>
    )

    render(): JSX.Element {
        return <>
            <TextField
                label={this.props.showLabel && this.props.fieldLabel}
                ariaLabel={this.props.fieldLabel}
                value={this.props.copyableValue}
                onRenderSuffix={() => this.renderCopyButton()}
                styles={{ root: { paddingBottom: 15 } }}
                readOnly
            />
        </>
    }
}